"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactHookForm = require("react-hook-form");
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var styles = {
  "srOnlyContent": "fHHBKM"
};
var buildErrorMessages = function buildErrorMessages(formErrors, fieldPrefix) {
  return Object.keys(formErrors).reduce(function (previousValue, fieldName) {
    if (formErrors[fieldName].types) {
      return previousValue.concat({
        field: fieldPrefix ? "".concat(fieldPrefix, ".").concat(fieldName) : fieldName,
        messages: Object.values(formErrors[fieldName].types)
      });
    }
    return previousValue.concat(buildErrorMessages(formErrors[fieldName], fieldPrefix ? "".concat(fieldPrefix, ".").concat(fieldName) : fieldName));
  }, []);
};
var SRErrors = function SRErrors() {
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    formErrors = _useFormContext.errors;
  var errors = buildErrorMessages(formErrors);
  if (errors.length === 0) return null;
  return /*#__PURE__*/_react["default"].createElement("span", {
    "aria-live": "assertive",
    className: styles.srOnlyContent
  }, errors.map(function (_ref) {
    var field = _ref.field,
      messages = _ref.messages;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: field
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, _extends({}, _messages["default"].srErrorsWarning, {
      values: {
        name: field
      }
    })), messages.map(function (msg, index) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: msg
      }, "".concat(index + 1, " - ").concat(msg));
    }));
  }));
};
var _default = exports["default"] = SRErrors;